import React from 'react'
import FilterCard from '../../components/filter-card'
import { UserTypeEnum, DegreeOptions, EducationLanguageOptions, ProgramsStatusOptions, CommonAllOption } from '../../utils/enums'

const ProgramsFilter = ({ filters, onFilterChange, onFilterSubmit, onClearFilters, onRefresh, loading }) => {


  const fields = [
    {
      type: 'input',
      name: 'search',
      placeholder: 'PROGRAMS_FILTERS_SEARCH_PLACEHOLDER',
      icon: 'zmdi zmdi-search'
    },
    {
      type: 'select',
      name: 'university_id',
      placeholder: 'PROGRAMS_FILTERS_UNIVERSITY_PLACEHOLDER',
      fetchUrl: 'universities',
      valueKey: 'id',
      labelKey: 'name',
      searchParamName: 'name',
    },
    {
      type: 'select',
      name: 'degree',
      colSize: 'col-lg-2 col-md-6 col-sm-12',
      placeholder: 'PROGRAMS_FILTERS_DEGREE_PLACEHOLDER',
      options: [
        { value: '', label: 'PROGRAMS_FILTERS_DEGREE_ALL' },
        ...DegreeOptions
      ]
    },
    {
      type: 'select',
      name: 'language',
      colSize: 'col-lg-2 col-md-6 col-sm-12',
      placeholder: 'PROGRAMS_FILTERS_LANGUAGE_PLACEHOLDER',
      options: [
        { value: '', label: 'PROGRAMS_FILTERS_LANGUAGE_ALL' },
        ...EducationLanguageOptions
      ]
    },
    {
      type: 'select',
      name: 'is_active',
      colSize: 'col-lg-2 col-md-6 col-sm-12',
      placeholder: 'PROGRAMS_FILTERS_STATUS_PLACEHOLDER',
      roleBased: true,
      roleAccess: UserTypeEnum.ADMIN,
      options: [
        { value: '', label: 'PROGRAMS_FILTERS_STATUS_ALL' },
        ...ProgramsStatusOptions
      ]
    }
  ]

  const defaultFilters = {
    search: '',
    university_id: '',
    degree: '',
    language: '',
    is_active: ''
  }

  return (
    <FilterCard
      filters={filters}
      onFilterChange={onFilterChange}
      onFilterSubmit={onFilterSubmit}
      onClearFilters={onClearFilters}
      onRefresh={onRefresh}
      loading={loading}
      title="PROGRAMS_FILTERS_TITLE"
      titleHide="PROGRAMS_FILTERS_HIDE"
      titleShow="PROGRAMS_FILTERS_SHOW"
      fields={fields}
      defaultFilters={defaultFilters}
      autoSubmitFields={['is_active', 'degree', 'language', 'university_id']}
    />
  )
}

export default ProgramsFilter


